
import { defineComponent } from 'vue'
import EncounterDetail from './EncounterDetail.vue'

export default defineComponent({
  name: 'EncounterList',
  props: ['patient'], 
  components: {
    EncounterDetail,
  },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
    {
        title: 'Visit #',
        align: 'start',
        sortable: false,
        key: 'visitNumber',
      },
      {
        title: 'Type',
        align: 'start',
        sortable: false,
        key: 'type',
      },
      { title: 'Date', key: 'date' },
      { title: 'Visit', key: 'visit' },
      { title: 'Movement', key: 'movement' },
      { title: 'Location', key: 'location' },
      { title: 'Class', key: 'patientClass', sortable: false },
      { title: 'Accomodation', key: 'accomodation', sortable: false },
      { title: 'Actions', key: 'actions', sortable: false },
    ],
    encounters: [],
    editedIndex: -1,
    editedItem: {
      type: '',
      date: '',
      visit: '',
      movement: '',
      location: '',
      patientClass: '',
      accomodation: ''
    },
    defaultItem: {
      type: '',
      date: '',
      visit: '',
      movement: '',
      location: '',
      patientClass: '',
      accomodation: ''
    },
  }),

  computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Add New Visit' : 'Edit Visit'
      }
    },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialogDelete (val) {
      val || this.closeDelete()
    },
  },

  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.encounters = [
        {
          visitNumber: 'VHP-230508',
          type: 'Procedure',
          date: '2023-04-01',
          visit: 'Procedure',
          movement: 'Repeat Visit',
          location: 'Procedure 123',
          patientClass: 'Private',
          accomodation: '1 Bedder'
        },
        {
          visitNumber: 'VHI-230508',
          type: 'Inpatient',
          date: '2023-03-01',
          visit: 'Admission',
          movement: 'Admission',
          location: 'Ward 12',
          patientClass: 'Private',
          accomodation: '1 Bedder'
        },
        {
          visitNumber: 'VHO-230505',
          type: 'Outpatient',
          date: '2023-02-01',
          visit: 'Consultation',
          movement: 'Repeat Visit',
          location: 'Eye Clinic',
          patientClass: 'Private',
          accomodation: 'Other'
        },
        {
          visitNumber: 'VHE-230502',
          type: 'Emergency',
          date: '2023-01-01',
          visit: 'Admission',
          movement: 'First Visit',
          location: 'Ward 12',
          patientClass: 'Private',
          accomodation: 'Other'
        }        
      ]
    },

    editItem (item) {
      this.editedIndex = this.encounters.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.editedIndex = this.encounters.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm () {
      this.encounters.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close () {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete () {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    save () {
      if (this.editedIndex > -1) {
        Object.assign(this.encounters[this.editedIndex], this.editedItem)
      } else {
        this.encounters.push(this.editedItem)
      }
      this.close()
    },

    onUpdateEncounter(value) {
      this.editedItem = value
    },
  }
})
